// convert all keys to strings
// which will be embedded into a form
export type FormInputs<T> = { [K in keyof T]: string };

export function formInputs<T>(data: FormInputs<T>) {
    return Object.entries(data)
        .map(([key, value]) => (
            <input type="hidden" name={key} value={String(value)} key={key}/>
        ));
}    